import { KnowledgeAreaSelectContent } from './KnowledgeAreaSelectContent';
export default KnowledgeAreaSelectContent;